import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { MdOutlineKeyboardDoubleArrowUp, MdOutlineKeyboardDoubleArrowDown } from "react-icons/md";
import React from "react";
import * as PropTypes from "prop-types";

import {formatMoney} from "../../../utilities/common";



export function GameTotals({ game, sort, onSort }) {
    return <>
        <Row className={"game-table-header mt-3"}>
            <Col xs={3} md={4}><h3>Player</h3></Col>
            <Col xs={3} md={2}><h3 onClick={() => onSort('buyIn')} className="text-end">{sort.sortBy === 'buyIn' ? <SortIcon sortOrder={sort.sortOrder} /> : null} Buy-In</h3></Col>
            <Col xs={3} md={2}><h3 onClick={() => onSort('cashOut')} className="text-end">{sort.sortBy === 'cashOut' ? <SortIcon sortOrder={sort.sortOrder} /> : null} Cash-Out</h3></Col>
            <Col xs={3} md={2}><h3 onClick={() => onSort('net')} className="text-end">{sort.sortBy === 'net' ? <SortIcon sortOrder={sort.sortOrder} /> : null} Net</h3></Col>
            <Col xs={12} md="auto"></Col>
        </Row>
        <Row>
            <hr/>
        </Row>
        <Row className={"game-table-header"}>
            <Col xs={3} md={4}><h3>Game Totals</h3></Col>
            <Col xs={3} md={2}><h3 className="money">{formatMoney(game.totalBuyIns)}</h3></Col>
            <Col xs={3} md={2}><h3 className="money">{formatMoney(game.totalCashOuts)}</h3></Col>
            <Col xs={3} md={2}>
                <h3 className={`money fw-bold ${game.totalNet >= 0 ? "text-success" : "text-danger"}`}>
                    {formatMoney(game.totalNet)}
                </h3>
            </Col>
            <Col xs={12} md="auto"></Col>
        </Row>
    </>;
}

const SortIcon = ({ sortOrder }) => {
    let arrow;
    switch(sortOrder) {
        case 'asc':
            arrow = <MdOutlineKeyboardDoubleArrowDown />;
            break;
        case 'desc':
            arrow = <MdOutlineKeyboardDoubleArrowUp />;
            break;
        default:
            arrow = null;
    }
    return <span>{arrow}</span>
}

GameTotals.propTypes = {game: PropTypes.object};
